import NoDataFound from 'components/NoDataFound';
import React from 'react';

const ErrorMessage = ({ error }) => {
  const { extensions, message } = error;

  const defaultErr = 'There is Error!';
  const errMsg = message?.split(':');
  const errorCode = extensions?.errorCode;

  if (errorCode === 503) {
    return (
      <p className="my-3">
        <NoDataFound message="Currently Service is Unavailable" />
      </p>
    );
  }

  if (error) {
    return (
      <p className="my-3">
        <NoDataFound
          message={
            extensions?.errorMessage || errMsg?.[1]?.trim() || defaultErr
          }
        />
      </p>
    );
  }
  return (
    <p className="my-3">
      <NoDataFound message={defaultErr} />
    </p>
  );
};

export default ErrorMessage;
